const baseUrl = '/admin'

function dashboard() {
  return baseUrl
}

const leaveRequestUrl = '/leave-request'

function leaveRequestUnresponded() {
  return `${baseUrl}${leaveRequestUrl}/unresponded`
}

function leaveRequestIndoTeam() {
  return `${baseUrl}${leaveRequestUrl}/indo-team`
}

function leaveRequestJapanTeam() {
  return `${baseUrl}${leaveRequestUrl}/japan-team`
}

function leaveRequestDetail({ id }: { id: string }) {
  return `${baseUrl}${leaveRequestUrl}/detail/${id}`
}

function leaveRequestEdit({ id }: { id: string }) {
  return `${baseUrl}${leaveRequestUrl}/edit/${id}`
}

const medicalReimbursementUrl = '/medical-reimbursement'

function medicalReimbursementUnresponded() {
  return `${baseUrl}${medicalReimbursementUrl}/unresponded`
}

function medicalReimbursementResponded() {
  return `${baseUrl}${medicalReimbursementUrl}/responded`
}

function medicalReimbursementEdit({ id }: { id: string }) {
  return `${baseUrl}${medicalReimbursementUrl}/edit/${id}`
}

function medicalReimbursementDetail({ id }: { id: string }) {
  return `${baseUrl}${medicalReimbursementUrl}/detail/${id}`
}

const admin = {
  dashboard,
  leaveRequestUnresponded,
  leaveRequestIndoTeam,
  leaveRequestJapanTeam,
  leaveRequestEdit,
  leaveRequestDetail,
  medicalReimbursementUnresponded,
  medicalReimbursementResponded,
  medicalReimbursementEdit,
  medicalReimbursementDetail,
}

export default admin
